<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title8"> </title-bar>
    <!-- <div style="margin-left: 10px; margin-right: 10px; margin-top: 10px">
      <img
        src="../../../assets/img/bonus/bonus6.png"
        width="100%"
        style="border-radius: 13px"
      />
    </div> -->
    <div style="position: relative; margin: 10px 10px 0 10px">
      <img
        src="../../../assets/img/bonus/bonus6.png"
        width="100%"
        style="border-radius: 13px"
      />
      <div style="position: absolute; top: 20px; left: 20px">
        <p
          style="font-weight: 800; font-size: var(--vk-fs-15); margin-bottom: 10px"
          v-html="$lang.common_txt240"
        ></p>
        <p v-html="$lang.common_txt241"></p>
      </div>
    </div>
    <div class="content-c">
      <div v-if="readError" class="read-error">{{ readError }}</div>
      <div class="content-c--c">
        <p class="content-c--c1">{{ $lang.bonus_txt39 }}</p>
        <p class="content-c--c2">{{ getCurrency }} {{ info.reliefAmount }}</p>
        <van-button
          size="large"
          class="custom-button"
          :class="{ active: isClaimUiDisabled() }"
          :disabled="claiming || isClaimUiDisabled()"
          @click="getJl"
        >
          {{ claiming ? ($lang.common_loading || 'Loading...') : $lang.Receber }}
        </van-button>
        <img
          class="content-c--c5"
          src="../../../assets/img/bonus/title-bg.png"
        />
      </div>
      <div
        class="d-flex f-t-15 f-w m-t-10 m-b-10"
        style="justify-content: center"
      >
        <span class="share-bot-l"></span>
        <span>{{ $lang.common_txt35 }}</span>
        <span class="share-bot-r"></span>
      </div>
      <div class="font-color" v-html="$lang.bonus_txt40"></div>
    </div>
  </div>
</template>
<script>
import { GetTeamRebateInit, ReceiveTeamRebateAmount } from '@/api/common'
import { failMessage as rewardFailMessage, hasRewardIssueProof, hasUnavailableMarker, isClaimSuccess as rewardClaimSuccess, isNeedLogin, isOkResponse, responseContent } from '../activity/rewardApi'
export default {
  name: 'teamRebates',
  components: {},
  data() {
    return {
      info: {},
      claiming: false,
      readError: ''
    }
  },
  mounted() {
    this.GetTeamRebateInit()
  },
  methods: {
    requireLogin() {
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    isRewardNeedLogin(res) {
      if (isNeedLogin(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (body.need_login === true || body.needLogin === true || [body.status, body.state, body.code, body.errorCode, body.need_login, body.needLogin].some(value => String(value || '').trim().toLowerCase() === 'need_login')) return true
        ;['content', 'data', 'page', 'extra'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    isFalseFlag(value) {
      const token = String(value == null ? '' : value).trim().toLowerCase()
      return value === false || value === 0 || token === 'false' || token === '0'
    },
    hasRewardWritableBlocker(res) {
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const writableFlags = [
          body.rewardWritable,
          body.reward_writable,
          body.claimWritable,
          body.claim_writable
        ]
        if (writableFlags.some(value => this.isFalseFlag(value))) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasRewardUnavailableMarker(res) {
      if (hasUnavailableMarker(res) || this.hasRewardWritableBlocker(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.readOnly,
          body.readOnlyMode,
          body.read_only_mode,
          body.readOnlyReward,
          body.read_only_reward,
          body.readOnlyAction,
          body.read_only_action,
          body.read_only,
          body.mock_fallback,
          body.not_implemented,
          body.not_supported,
          body.need_login,
          body.needLogin,
          body.notSupported,
          body.unsupported,
          body.technicalMarker,
          body.technical_marker,
          body.backendFailure,
          body.backend_failure,
          body.technicalError,
          body.technical_error,
          body.technicalException,
          body.technical_exception,
          body.fallback,
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.writeBlocked,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.falseProof,
          body.false_proof,
          body.failClosed,
          body.fail_closed,
          body.unimplemented,
          body.failed,
          body.readonly,
          body.notImplemented,
          body.mock,
          body.mockMode,
          body.mock_mode,
          body.mockFallback,
          body.write_blocked,
          body.stub,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.readOnlyMessage,
          body.unavailableReason,
          body.status,
          body.state,
          body.result,
          body.code,
          body.errorCode,
          body.paymentStatusUnconfirmed,
          body.payment_status_unconfirmed,
          body.paymentStatus,
          body.payment_status,
          body.rewardStatus,
          body.reward_status
        ]
        const proofValues = [
          body.writeProof,
          body.write_proof,
          body.rewardProof,
          body.reward_proof,
          body.orderProof,
          body.order_proof,
          body.affectedProof,
          body.affected_proof,
          body.serverProof,
          body.server_proof
        ]
        if (proofValues.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return true
        const markers = ['未接入', 'mock', 'mockMode', 'mock_mode', 'fallback', 'dataUnavailable', 'data unavailable', 'data_unavailable', 'readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'stub', '只读', 'readOnlyMode', 'read_only_mode', 'readOnlyReward', 'read_only_reward', 'readOnlyAction', 'read_only_action', '阻止假成功', 'writeBlocked', 'paymentStatusUnconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'writeProof', 'write_proof', 'writeProof:false', 'write_proof:false', 'falseProof', 'false_proof', 'false proof', 'failClosed', 'fail_closed', 'fail closed', 'backendBlocked', 'rewardBackendBlocked', 'backend_blocked', 'reward_backend_blocked', 'technicalMarker', 'technical_marker', 'technical marker', 'backendFailure', 'backend_failure', 'backend failure', 'technicalException', 'technical_exception', 'technical exception', 'technicalError', 'technical_error', 'technical error', 'not_implemented', 'not_supported', 'not supported', 'need_login', 'need login', 'need-login', 'unsupported', 'unimplemented', 'failed']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    failMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
    },
    safeToast(message, icon = 'cross') {
      if (typeof this.$toast === 'function') {
        this.$toast({
          message,
          icon
        })
      }
    },
    showFailToast(res, fallback) {
      this.safeToast(this.failMessage(res, fallback), 'cross')
    },
    showReadFailToast(res, fallback) {
      this.readError = `${this.failMessage(res, fallback || this.$lang.network_error || '活动请求失败，请稍后重试。')}，已保留已加载数据。`
      this.safeToast(this.readError, 'cross')
    },
    isClaimUiDisabled() {
      return !!this.readError || !this.info || this.info.promoStatus !== 'not_receive'
    },
    firstValue(...values) {
      return values.find(value => value !== undefined && value !== null && value !== '')
    },
    safeNumber(value, fallback = 0) {
      const n = Number(typeof value === 'string' ? value.replace(/,/g, '') : value)
      return Number.isFinite(n) ? n : fallback
    },
    normalizedReadBody(content) {
      const c = content || {}
      if (this.firstValue(
        c.reliefAmount,
        c.relief_amount,
        c.amount,
        c.availableAmount,
        c.amountAvailable,
        c.rebateAmount,
        c.rewardAmount,
        c.promoStatus,
        c.status,
        c.receiveStatus,
        c.receive_status,
        c.claimStatus,
        c.claim_status
      ) !== undefined) return c
      const nested = this.firstValue(c.info, c.detail, c.details)
      if (nested && typeof nested === 'object' && !Array.isArray(nested)) return nested
      const row = this.firstValue(
        Array.isArray(c.records) ? c.records[0] : null,
        Array.isArray(c.list) ? c.list[0] : null,
        Array.isArray(c.dataList) ? c.dataList[0] : null,
        Array.isArray(c.items) ? c.items[0] : null
      )
      if (row && typeof row === 'object') return row
      return c
    },
    normalizedPromoStatus(c) {
      return this.firstValue(
        c.promoStatus,
        c.status,
        c.receiveStatus,
        c.receive_status,
        c.claimStatus,
        c.claim_status,
        c.state
      )
    },
    isReadableInitResponse(res) {
      const statusToken = String(this.firstValue(res && res.status, res && res.state, res && res.result, res && res.code, res && res.errorCode, res && res.success) || '').trim().toLowerCase()
      if (!isOkResponse(res) && !['ok', 'success', 'succeeded', 'true', '1', '0'].includes(statusToken) && !this.hasRewardUnavailableMarker(res)) return false
      const content = responseContent(res)
      const body = this.normalizedReadBody(content)
      return this.firstValue(
        body.reliefAmount,
        body.relief_amount,
        body.amount,
        body.availableAmount,
        body.amountAvailable,
        body.rebateAmount,
        body.rewardAmount,
        body.promoStatus,
        body.status,
        body.receiveStatus,
        body.receive_status,
        body.claimStatus,
        body.claim_status
      ) !== undefined
    },
    hasBlockingReadFailureMarker(res) {
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const values = [
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.backendFailure,
          body.backend_failure,
          body.technicalMarker,
          body.technical_marker,
          body.technicalError,
          body.technical_error,
          body.technicalException,
          body.technical_exception,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.unavailableReason
        ]
        const markers = ['dataUnavailable', 'data unavailable', 'data_unavailable', 'readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'backendBlocked', 'backend blocked', 'backend_blocked', 'rewardBackendBlocked', 'reward backend blocked', 'reward_backend_blocked', 'backendFailure', 'backend failure', 'backend_failure', 'technicalMarker', 'technical marker', 'technical_marker', 'technicalError', 'technical error', 'technical_error', 'technicalException', 'technical exception', 'technical_exception']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    normalizeInfo(content, source) {
      const c = content || {}
      const body = this.normalizedReadBody(c)
      const disabled = this.hasRewardUnavailableMarker(source || c) ||
        this.hasRewardUnavailableMarker(c) ||
        this.hasRewardUnavailableMarker(body) ||
        body.rewardWritable === false ||
        String(body.rewardWritable).trim().toLowerCase() === 'false' ||
        body.writeEnabled === false ||
        String(body.writeEnabled).trim().toLowerCase() === 'false' ||
        c.rewardWritable === false ||
        String(c.rewardWritable).trim().toLowerCase() === 'false' ||
        c.writeEnabled === false ||
        String(c.writeEnabled).trim().toLowerCase() === 'false'
      const promoStatus = this.normalizedPromoStatus(body)
      return {
        ...c,
        ...body,
        reliefAmount: this.safeNumber(this.firstValue(
          body.reliefAmount,
          body.relief_amount,
          body.amount,
          body.availableAmount,
          body.amountAvailable,
          body.rebateAmount,
          body.rewardAmount,
          c.reliefAmount,
          c.relief_amount,
          c.amount
        ), 0),
        promoStatus: disabled ? '' : (promoStatus || '')
      }
    },
    hasRewardWriteProof(res) {
      if (this.hasRewardUnavailableMarker(res)) return false
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const proofs = [
          body.writeProof,
          body.write_proof,
          body.affectedProof,
          body.affected_proof,
          body.affectedRowsProof,
          body.affected_rows_proof,
          body.count,
          body.serverProof,
          body.server_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (proofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return false
        const positiveProofs = [
          body.rewardProof,
          body.reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (positiveProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const recordProofs = [
          body.recordNo,
          body.record_no,
          body.recordId,
          body.record_id,
          body.rewardRecordNo,
          body.reward_record_no,
          body.rewardRecordId,
          body.reward_record_id,
          body.receiveRecordNo,
          body.receive_record_no,
          body.receiveRecordId,
          body.receive_record_id,
          body.claimRecordNo,
          body.claim_record_no,
          body.claimRecordId,
          body.claim_record_id
        ]
        const hasRecordProof = recordProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })
        const aliasProofs = [
          body.serverRewardProof,
          body.server_reward_proof
        ]
        if (hasRecordProof && aliasProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const concreteProofs = [
          body.rewardProof,
          body.reward_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (concreteProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalmarker', 'technical_marker', 'backendfailure', 'backend_failure', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasExplicitRewardSuccess(res) {
      const c = responseContent(res)
      return [
        c.receiveSuccess,
        c.claimSuccess,
        c.signSuccess,
        c.paySuccess,
        c.success,
        c.received,
        c.claimed,
        c.signed
      ].some(value => value === true || value === 1 || ['1', 'true', 'success', 'ok'].includes(String(value == null ? '' : value).trim().toLowerCase()))
    },
    isReceiveSuccess(res) {
      return !this.hasRewardUnavailableMarker(res) && rewardClaimSuccess(res) && this.hasExplicitRewardSuccess(res) && (hasRewardIssueProof(res) || this.hasRewardWriteProof(res)) && this.hasRewardWriteProof(res)
    },
    async getJl() {
      if (this.claiming) return
      if (!this.token) {
        this.requireLogin()
        return
      }
      if (this.isClaimUiDisabled()) {
        this.showFailToast(null, this.readError || this.$lang.mc_claim_failed || 'This feature is temporarily unavailable. Please try again later.')
        return
      }
      this.claiming = true
      try {
        const data = await ReceiveTeamRebateAmount()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isReceiveSuccess(data)) {
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
          this.GetTeamRebateInit()
        } else {
          this.showFailToast(data)
        }
      } catch (e) {
        this.showFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      } finally {
        this.claiming = false
      }
    },
    async GetTeamRebateInit() {
      try {
        const data = await GetTeamRebateInit()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.hasBlockingReadFailureMarker(data)) {
          this.showReadFailToast(data)
        } else if (this.isReadableInitResponse(data)) {
          this.info = this.normalizeInfo(responseContent(data), data)
          this.readError = ''
        } else {
          this.showReadFailToast(data)
        }
      } catch (e) {
        this.showReadFailToast(e, this.$lang.network_error || '活动请求失败，请稍后重试。')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  padding: 0% 3% 10% 3%;
  // margin-top: -85px;
}
.read-error {
  margin-top: 8px;
  color: #f56c6c;
  font-size: var(--vk-fs-xs);
  line-height: 16px;
  text-align: center;
}
.content-c--c {
  margin-top: 10px;
  position: relative;
  border-radius: 15px;
  width: 100%;
  background: @cont-bg;
  height: 155px;
  border: 1px solid @info2-color;
}
.content-c--c1 {
  position: absolute;
  font-size: var(--vk-fs-15);
  left: 5%;
  top: 10%;
  font-weight: bold;
}
.content-c--c2 {
  position: absolute;
  font-size: var(--vk-fs-2xl);
  left: 5%;
  top: 29%;
  font-weight: bold;
  color: @info-color;
}
.active {
  // box-shadow: 0 4px 1px #4a4a4a !important; /* 阴影效果 */
  background: #9b9b9b !important;
  border-bottom: 0px solid #494949 !important;
}
.custom-button {
  opacity: 1;
  position: absolute;
  margin-top: 15px;
  width: 130px;
  height: 38px;
  left: 5%;
  bottom: 15%;
  border-radius: 13px;
}
.content-c--c5 {
  position: absolute;
  right: 15px;
  width: 152px;
  top: 12%;
}
.content-c2 {
  font-size: var(--vk-fs-lg);
  margin-top: 18px;
  background-image: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 2px 10px;
}

.content-c4 {
  font-size: var(--vk-fs-md);
  font-weight: bold;
  margin-top: 18px;
  // background: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 3px 5px;
}
</style>
